export const getIsDynamicBundle = () => {
  var _window$swag;
  const tenantStoreSettings = window.swag && ((_window$swag = window.swag) === null || _window$swag === void 0 ? void 0 : _window$swag.storeSettings);
  return Boolean(tenantStoreSettings);
};